import React from 'react';
import PropTypes from 'prop-types';
import { ASearchField } from '../atoms';

export default function MTableHeader({ columns, onSearch }) {
	const columnClass = `m-table-column--${columns.length}`;
	let searchField;

	if (onSearch) {
		searchField = (
			<ASearchField
				id="tableSearch"
				onClick={onSearch}
				onChange={onSearch}
				className="header-search"
			/>
		);
	}

	return (
		<article className="m-table-header">
			<div className={`header-body ${columnClass}`}>
				{
					columns.map(column => <p className="table-title" key={column}>{column}</p>)
				}
			</div>
			<div>
				{searchField}
			</div>
		</article>
	);
}

MTableHeader.propTypes = {
	columns: PropTypes.array.isRequired,
	onSearch: PropTypes.func,
};

MTableHeader.defaultProps = {
	onSearch: undefined,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.table-header.js